/**
 * Inspect values.
 *
 * @internal
 */ export function inspect(value, colors) {
  // deno-lint-ignore no-explicit-any
  const { Deno } = globalThis;
  return Deno?.inspect(value, {
    depth: 1,
    colors,
    trailingComma: false
  }) ?? JSON.stringify(value, null, 2);
}
//# sourceMappingURL=inspect.js.map